import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { connect } from "react-redux";
import * as d from "../../reducers/domainReducer";
import * as types from "../../constants/actionTypes";
import MyChartContainer from "./MyChartContainer";
import { useHistory } from "react-router-dom";
/*`${window.serverData.data.myChartBaseUrl}app/communication-center/conversation?id=WP-24xDJze9pGAwob3gvx3BZeXg-3D-3D-24kaL7Rbvm03sRbz9iCXSEiEq6LWHfJQ2g8O3guVaot5k-3D`*/
const MessagesAll = (props) => {
    //const [redirectUrl, setRedirect] = useState('');
    const history = useHistory();
    useEffect(() => {
        logUI("MBHWeb.UI.MessagesAll.ComponentDidMount", new Date(), Tools.getURLPath());
    }, []);

    //console.info(`MessagesAll mode messages, src ${location.href}`);

    const subMode = props.conversationID ? conversation : '';
    const dtile = props.isDemoLoaded ? <MyChartContainer
        id="MessagesAll"
        title="Messages"
        mode="messages"
        submode={subMode}
        //ignoreTouch={(redirectUrl!=='') }
        //redirectUrl={redirectUrl}
        src={`${window.serverData.data.myChartBaseUrl}app/communication-center${location.search}`}
        events={[{ elements: "button._actionable.Topic.selectionOption:not(.titleOnly)", eventName: "click", message: "buttonChoice", containerId: "appPopupRoot", dataTile: "MessagesAll" },
            { elements: "#appRoot .ConversationMessages button", eventName: "click", message: "reply", containerId: "appRoot", dataTile: "MessagesAll" },
            { elements: "#appRoot .ConversationMessages button.sendMsg", eventName: "click", message: "send", containerId: "appRoot", dataTile: "MessagesAll" }        ]}
        onMessage={(event) => { doEventMatch(event, history,props) }}
        key={props.currentUser && props.currentUser.displayName}
        containerClass="message-container"
        onIframeLoaded={(isLoaded) => {
            console.info(`MessagesAll onIframeLoaded isLoaded? ${isLoaded}`);
        }}
    /> : <div>loading</div>;
    return dtile;


}
const doEventMatch = (event, history,props) => {
    console.info('MessagesAll doEventMatch ', event);
    try {
        if(event.data?.evt?.dataTile === "MessagesAll") {
            if (event.data?.bswElement?.innerText.indexOf('Scheduling') >= 0 && event.data?.bswElement?.className.indexOf('selectionOption') >= 0) {//mychartDataTile
                //document.getElementById('mychartDataTile').style.display = 'none';
                document.getElementById(event.data?.evt?.dataTile).remove();
                history.push('/schedulenow');
                console.info('MessagesSend buttonChoice after histoyr push');
            }
            if (event.data?.bswElement?.innerText.indexOf('Reply') >= 0) {
                console.info('MessagesSend button Reply ', event);
                props.touch(true);
            }
            if (event.data?.bswElement?.innerText.indexOf('Send') >= 0) {
                console.info('MessagesSend button Send ',event);
                props.touch(false);
            }


        }
    } catch (e) {
        console.info('MessagesSend buttonChoice error,event', e, event);
    }
}
const mapStateToProps = (state) => {
    return {
        currentUser: d.hydrateProxyUser(state.domain.cu),
        isMedicalAdvice: state.memberships.hasAuthorizedFeatureMedicalAdvice,
        isDemoLoaded: state.myChartDataTile.myChartPreLoaded,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        forceReload: () => dispatch({ type: types.RELOAD_KEY }),
        touch: (isTouched) => dispatch({ type: types.MYCHART_DATA_TILE_TOUCHED, data: { touched: isTouched } })
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(MessagesAll);